import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
/**
 * Conditional class names with Tailwind conflict resolution.
 *
 * `twMerge` is what makes the `className` prop on our primitives actually work:
 * `<Button className="px-8">` overrides the component's own `px-4` instead of
 * producing two competing declarations whose winner depends on stylesheet
 * ordering.
 */
export function cn(...inputs) {
    return twMerge(clsx(inputs));
}
//# sourceMappingURL=cn.js.map